import { Navigate, useLocation } from 'react-router';

import { rememberedAccount } from '../api/session';
import { DEFAULT_LOCALE, detectLocale } from '../i18n/config';

/** `/` in the dev server. In builds, the prerendered dist/index.html does the same redirect. */
export function RootRedirect() {
  const { search } = useLocation(); // e.g. an invite link's ?ref=CODE
  if (rememberedAccount() !== null) {
    return <Navigate to={`/app${search}`} replace />;
  }
  const locale =
    typeof navigator === 'undefined' ? DEFAULT_LOCALE : detectLocale(navigator.languages);
  return <Navigate to={`/${locale}/${search}`} replace />;
}
